
import { useState } from 'react';
import Hero from './components/Hero';
import ProblemReframing from './components/ProblemReframing';
import TrustProof from './components/TrustProof';
import ExperienceValue from './components/ExperienceValue';
import ProductLineup from './components/ProductLineup';
import ModelDiagnosis from './components/ModelDiagnosis';
import RecruitmentBranding from './components/RecruitmentBranding';
import ROISection from './components/ROISection';
import B2BOffer from './components/B2BOffer';
import FooterCTA from './components/FooterCTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#f5f3ef]">
      <Hero />
      <ProblemReframing />
      <TrustProof />
      <ExperienceValue />
      <ProductLineup />
      <ModelDiagnosis />
      <RecruitmentBranding />
      <ROISection />
      <B2BOffer />
      <FooterCTA />
      <Footer />
    </div>
  );
}
